import { render } from "./SubscriptionComponent.vue?vue&type=template&id=45e51d34"
import script from "./SubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./SubscriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__